import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BoletoAcertoDto } from '../../models/boleto-acerto.model';
import { AgreementDetailService } from '../agreement-detail.service';

@Component({
    selector: 'add-boleto-dialog',
    templateUrl: './add-boleto-dialog.component.html',
    styleUrls: ['./add-boleto-dialog.component.scss'],
})
export class AddBoletoDialogComponent {
    searchTerm = '';
    boletos: BoletoAcertoDto[] = [];
    selectedBoletos: BoletoAcertoDto[] = [];
    loading = false;
    searched = false;

    constructor(
        private dialogRef: MatDialogRef<AddBoletoDialogComponent>,
        private agreementDetailService: AgreementDetailService,
        @Inject(MAT_DIALOG_DATA) private data: { companyId: string; codigoAcerto: string },
    ) {}

    onSearch(): void {
        if (!this.searchTerm) return;
        this.loading = true;
        this.searched = true;
        this.selectedBoletos = [];

        this.agreementDetailService.searchBoletosForAdd(this.searchTerm.trim()).subscribe({
            next: (boletos) => {
                this.boletos = boletos;
                this.loading = false;
            },
            error: () => {
                this.boletos = [];
                this.loading = false;
            },
        });
    }

    toggleSelection(boleto: BoletoAcertoDto): void {
        const idx = this.selectedBoletos.indexOf(boleto);
        if (idx >= 0) {
            this.selectedBoletos.splice(idx, 1);
        } else {
            this.selectedBoletos.push(boleto);
        }
    }

    isSelected(boleto: BoletoAcertoDto): boolean {
        return this.selectedBoletos.includes(boleto);
    }

    onConfirm(): void {
        if (!this.selectedBoletos.length) 
            return;
        
        const codigosCarne = this.selectedBoletos.map(boleto => boleto.codigoCarne);
        this.agreementDetailService.addBoletosToAgreement(this.data.companyId, this.data.codigoAcerto, codigosCarne).subscribe({
            next: () => {
                this.dialogRef.close(this.selectedBoletos);
            },
            error: () => {
                // Handle error
            }
        });
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
